import axios from 'axios'
import { BASE_URL } from '../configs/configs'
import { immerSetPrefs, getPrefs } from './usePrefsStore'
import { getVersions, immerSetVersions } from './useVersionsStore'
import { locationUpdate } from './locationActions'

const url = `${BASE_URL}/cncapp/app-data`
const urlVersion = `${BASE_URL}/cncapp/app-versions`

// Actions defs
// fetch version
export const fetchVersion = async () => {
  const { versions } = getVersions()

  axios.get(urlVersion)
    .then(({ data }) => {
      const newvs = JSON.parse(data.versions)
      const isNewData = newvs.dataVersion && newvs.dataVersion !== versions.dataVersion
      const isNewApp = newvs.appVersion && newvs.appVersion !== versions.appVersion
      if (isNewData || isNewApp) {
        immerSetVersions(state => {
          state.versions = { ...newvs }
        })
        immerSetPrefs(state => {
          state.fetched = false
        })
      }
    })
    .then(() => {
      if (!getPrefs().fetched) {
        fetchAppData()
      }
    })
    .catch(err => console.error('fetchVersion failed:', err.message))
}

// ?locId= is optional and forward-looking (see route-app-data.js) — reads
// it once from the page's own URL at load time so a multi-location
// deployment can be pointed at a specific location without a rebuild;
// omitting it preserves today's single-location behavior (defaults to the
// first active location).
const requestedLocId = new URLSearchParams(window.location.search).get('locId')

// fetch initial app data, save to localStorage
export const fetchAppData = async () => {
  axios.get(requestedLocId ? `${url}?locId=${encodeURIComponent(requestedLocId)}` : url)
    .then(res => {
      const { data: { catalog, locations, locId, statuses } } = res
      immerSetPrefs(state => {
        if (catalog) {
          const jsonCatalog = JSON.parse(catalog)
          if (jsonCatalog.categories && Object.keys(jsonCatalog.categories).length > 0) {
            state.fetched = true
            state.catalog = jsonCatalog

            state.locations = JSON.parse(locations)

            const stats = JSON.parse(statuses)
            state.statuses = stats
            state.statusNames = Object.keys(stats).reduce((acc, key) => {
              return { ...acc, [stats[key]]: key }
            }, {})
          }
        }
      })
      // this deployment serves exactly one location (chosen via ?locId= or,
      // failing that, the server's default active location) — no customer
      // picker, so this is the only place locId gets set.
      if (locId) locationUpdate(locId)
    })
    .catch(err => console.error('fetchAppData failed:', err.message))
}

export const getLocation = locId => {
  const locations = getPrefs().locations
  return locations.find(loc => loc.locId === locId)
}

export const getClosedDates = locId => {
  const location = getLocation(locId)
  return location && location.closedDates
}

